import { useState, type FormEvent } from "react";
import { api, unwrap } from "../api/client";
import { t } from "../lib/i18n";
import { Button, Field, FormError, Modal, TextInput, useToast } from "./ui";

export function PasswordModal({ onClose }: { onClose: () => void }) {
  const toast = useToast();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (next !== confirm) {
      setError(t("Les deux nouveaux mots de passe diffèrent."));
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await unwrap(api.POST("/api/auth/password", { body: { current, new: next } }));
      toast(t("Mot de passe modifié. Vos autres sessions ont été fermées."));
      onClose();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal open title={t("Changer mon mot de passe")} onClose={onClose}
      footer={<>
        <Button variant="ghost" onClick={onClose}>{t("Annuler")}</Button>
        <Button variant="primary" type="submit" form="password-form" disabled={busy}>{t("Enregistrer")}</Button>
      </>}>
      <form id="password-form" onSubmit={submit} className="flex flex-col gap-4">
        <Field label={t("Mot de passe actuel")} htmlFor="pw-current">
          <TextInput id="pw-current" type="password" autoComplete="current-password" required autoFocus
            value={current} onChange={(e) => setCurrent(e.target.value)} />
        </Field>
        <Field label={t("Nouveau mot de passe")} htmlFor="pw-new" hint={t("10 caractères minimum.")}>
          <TextInput id="pw-new" type="password" autoComplete="new-password" required minLength={10}
            value={next} onChange={(e) => setNext(e.target.value)} />
        </Field>
        <Field label={t("Confirmer")} htmlFor="pw-confirm">
          <TextInput id="pw-confirm" type="password" autoComplete="new-password" required
            value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </Field>
        <FormError message={error} />
      </form>
    </Modal>
  );
}
